export interface SavingsFormulaOption {
    label: string;
    value: string;
}

export interface SavingsEntry {
    platform: string;
    region_name: string;
    blended_cpc_ref: number | null;
}

const BASE_OPTIONS: SavingsFormulaOption[] = [
    { label: 'Savings: Average', value: 'm1' },
    { label: 'Savings: Month over Month', value: 'y1' },
];

const CUSTOM_OPTION: SavingsFormulaOption = { label: 'Savings', value: 'custom' };

/**
 * Returns true when at least one savings entry has a non-null blended_cpc_ref.
 */
export function hasCustomSavingsConfigured(
    savings: SavingsEntry[] | null | undefined
): boolean {
    return (savings ?? []).some((s) => s.blended_cpc_ref != null);
}

/**
 * Returns the savings formula options for the selector.
 * The "Savings" (custom) option is included only when custom savings are configured
 * AND the savings_custom column exists in BigQuery.
 */
export function getSavingsFormulaOptions(
    savings: SavingsEntry[] | null | undefined,
    savingsCustomAvailable?: boolean
): SavingsFormulaOption[] {
    if (savingsCustomAvailable && hasCustomSavingsConfigured(savings)) {
        return [...BASE_OPTIONS, CUSTOM_OPTION];
    }
    return BASE_OPTIONS;
}

/**
 * Returns the default savings formula based on workspace config.
 * Defaults to 'custom' when a reference CPC is configured and data is available, otherwise 'm1'.
 */
export function getDefaultSavingsFormula(
    savings: SavingsEntry[] | null | undefined,
    savingsCustomAvailable?: boolean
): string {
    return (savingsCustomAvailable && hasCustomSavingsConfigured(savings)) ? 'custom' : 'm1';
}
